import { topicsData } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-hashtag text-sm"></i>
            </div>
            热门话题
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            大家都在关注什么
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            追踪91视频网站和久久视频社区最热话题标签，实时了解全网影视讨论风向
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topicsData.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="group block p-4 md:p-5 rounded-xl bg-background-100 hover:bg-accent-50 border border-background-200/60 hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-2">
                <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {item.label}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
              </div>
              <div className="text-sm font-bold text-foreground-900 group-hover:text-accent-600 transition-colors mb-1 whitespace-nowrap">
                #{item.tag}
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}